import SessionEventProto from "../session-event-proto"

type Header = {
    goal            : {
        rootGoalId  : ID,
        id          : ID
    }
    parentGoalId    : ID
    isBulkUpdate    : boolean
}

const debug = false
// const debug = "SessionGoalEvent"

export default class SessionGoalEvent extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)
        this.header     = {
            goal            : sessionEvent.goal,
            parentGoalId    : sessionEvent.parentGoal?.id,
            isBulkUpdate    : sessionEvent.isBulkUpdate,
        }
    }

    process() {
        if (this.isDifferentCompany()) return false

        const data = _.cloneDeep(this.data)

        debug && console.log(debug, 'process', data.type, data)

        gd.modelBus.newUpdate('goal', this.method, this.header.goal.id, data, this.header)
    }
}
